import { useState } from "react";
import { apiClient } from "./common";

// パスワードリセット確定（リンク経由の新パスワード設定）。
// 生成済み OpenAPI クライアントには本エンドポイントが未定義のため、
// apiClient(axios) で直接呼び出す。パスは BASE_PATH と同じ /api/v1 配下。
export const useApiPasswordResetConfirm = () => {
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const submit = async (token: string, newPassword: string) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await apiClient.post(
        "/api/v1/users/passwordResetConfirm",
        { token, new_password: newPassword }
      );
      return response.data === true;
    } catch (err: any) {
      const message =
        err?.response?.data?.error ||
        "パスワードの再設定に失敗しました。リンクの有効期限が切れている可能性があります。";
      setError(message);
      console.error(err);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { submit, error, isLoading };
};
